<script lang="ts" setup>
import type { IconName } from '~ds/lib/icons';

import { Icon } from '~ds/components/ui/icon';
import { ICONS } from '~ds/lib/icons';
import { useI18n } from 'vue-i18n';

interface Props {
  direction: 'left' | 'right';
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
});

const emit = defineEmits<{
  click: [e: MouseEvent];
}>();

const iconPath = computed<IconName>(() => {
  return props.direction === 'left' ? ICONS.arrowLeft : ICONS.arrowRight;
});

const { t } = useI18n();

const ariaLabel = computed(() => {
  return props.direction === 'left'
    ? t('unified.common.carousel.previousSlide')
    : t('unified.common.carousel.nextSlide');
});

const onClick = (event: MouseEvent) => {
  if (props.disabled) {
    return;
  }
  emit('click', event);
};

const buttonClasses = computed(() => {
  return twMerge(
    cva('transition-opacity mx-3 my-4 p-1 md:p-2 bg-white rounded-full shadow-sm transition-all duration-300 focus-visible:ring-2 focus-visible:ring-foreground focus-visible:ring-offset-2', {
      variants: {
        disabled: {
          true: 'cursor-not-allowed bg-white text-muted-foreground shadow-none ',
          false: 'cursor-pointer hover:bg-accent/50 hover:shadow-md',
        },
      },
    })({
      disabled: props.disabled,
    }),
  );
});
</script>

<template>
  <button
    type="button"
    :class="buttonClasses"
    :aria-label="ariaLabel"
    :disabled="disabled"
    @click="onClick"
  >
    <Icon
      :name="iconPath"
      size="lg"
    />
  </button>
</template>
